module.exports = __webpack_public_path__ + "img/1696320382037-WhatsApp Image 2023-10-03 at 14.35.10.jpeg.fdde2bde.webp";